import { Component, OnInit, inject } from '@angular/core';

import { UnivPrefsService } from '_services/univ-prefs.service';

@Component({
    selector: 'app-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.css'],
    standalone: false
})
export class StatusComponent implements OnInit {
  ups = inject(UnivPrefsService);


  title = 'Status Page';
  message = 'This page will show status if a school is unavailable.';
  ngOnInit() {
    const prefs = this.ups.preferences();
    if (prefs) {
      const status = prefs.status;
      switch (status) {
        case 'HOLD':
          this.title = 'Temporarily Unavailable';
          this.message = prefs.universityName + ' is temporarily unavailable. Please contact the schools financial aid office for more information.';
          break;
        case 'DEACTIVATED':
          this.title = 'School no longer available';
          this.message = prefs.universityName + ' is no longer supporting this Net Price Calculator.';
          break;
        default:
          break;
      }
    }
  }

}
